
import { Options, Vue } from "vue-class-component";

import { auth } from "../firebase";

@Options({
  methods: {
    login() {
      auth
        .signInWithEmailAndPassword(this.email, this.password)
        .then(() => {
          this.$router.push({ name: "Home" });
        })
        .catch((err) => {
          alert(err.message);
        });
    },
    reset() {
      (this.email = ""), (this.password = "");
    },
  },
  data() {
    return {
      email: "",
      password: "",
    };
  },
})
export default class Login extends Vue {}
